import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { showFilterModal } from '../../redux/product/product'
import sortBy from '../../actions/sortBy'
import ListerTools from '../../components/ListerTools/ListerTools'

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleShowFilterModalClick: () => {
    dispatch(showFilterModal())
  },
  handleSortByChange: sortByValue => {
    dispatch(sortBy(sortByValue, ownProps.history))
  }
})

// This needs the Router props, specifically `history` to use in `sortBy`.
// This could be avoided with react-router-redux.
export default withRouter(connect(null, mapDispatchToProps)(ListerTools))
